import React, {Component} from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { Main, ResultPage } from './pages';

class App extends Component{
  render(){
    return(
      <div>
        <Route exact path="/"  component={Main}/>
        <Route path="/resultPage" component={ResultPage}/>
      </div>
    );
  }
}

export default connect(
  (state) => ({

  }),
  (dispatch) => ({
      
  })
)(App);